/**
 * Red hover indicator for cells that the engine considers INVALID for
 * the active interaction (spawn from hand, drag-to-move, cell-pick,
 * token placement). One DOM node mounted permanently; the per-frame
 * projector in GameBoard.updateInvalidCellHoverOverlay positions and
 * sizes it on the cell under the cursor when applicable, otherwise
 * hides it (display: none).
 *
 * Visual: red pulsing halo matching the geometry of the green/gold
 * valid-cell halos. Same z-band so it sits in the same visual layer.
 */
export default function InvalidCellHoverOverlay({ registerRef }) {
  return (
    <div
      aria-hidden="true"
      ref={(el) => registerRef(el)}
      className="invalid-cell-hover-halo"
      style={{ display: 'none' }}
    />
  );
}
